import React, { Component } from 'react'
import IconMagnifier from '../../assets/icons/IconMagnifier'
import styles from './SearchInput.module.css'

class SearchInput extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isFocus: false
        }
    }

    render() {
        if (this.props.canSubmit) {
            return (
                <form 
                    onSubmit={this.props.onSubmit} 
                    className={`${styles['search-input']} ${this.state.isFocus ? styles['active'] : ''} flex items-center overflow-hidden rounded-md border border-gray-300 bg-white ${this.props.className || ''}`}
                    style={this.props.style}
                >
                    <input 
                        onChange={this.props.onChange} 
                        className={`${this.props.inputClassName || ''} w-full outline-none px-4 py-3 bg-transparent`} 
                        type="text" 
                        placeholder={this.props.placeholder} 
                        onFocus={() => this.setState({ isFocus: true })}
                        onBlur={() => this.setState({ isFocus: false })}
                        style={this.props.inputStyle}
                    />
                    <div className="px-4 py-3 pl-0">
                        <IconMagnifier 
                            className="cursor-pointer select-none hover:text-olddarkblue transition duration-100" 
                            onClick={this.props.onSubmit} 
                        />
                    </div>
                </form>
            )
        }

        return (
            <div className={`${styles['search-input']} ${this.state.isFocus ? styles['active'] : ''} flex items-center overflow-hidden rounded-md border border-gray-300 bg-white ${this.props.className || ''}`}>
                <input 
                    onChange={this.props.onChange} 
                    className={`${this.props.inputClassName || ''} w-full outline-none px-4 py-3 bg-transparent`} 
                    type="text"
                    placeholder={this.props.placeholder} 
                    onFocus={() => this.setState({ isFocus: true })}
                    onBlur={() => this.setState({ isFocus: false })}
                    style={this.props.inputStyle}
                />
                <div className="px-4 py-3 pl-0">
                    <IconMagnifier className="select-none" />
                </div>
            </div>
        )
    }
}

SearchInput.defaultProps = {
    canSubmit: false
}

export default SearchInput